import React from "react";
import { OVERVIEW, COMPETITION } from "../../../../../core/theme/reportTheme";
import { BUSINESS_TYPE_LABELS } from "../../../../../core/data/businessTypes/labels";
import { providerError } from "../../../../../core/data/marketOverviewText";

const HOW_WE_CLASSIFY =
  "This is AdAudit's classification, not the business's own. In order: your corrections; " +
  "then AdAudit's lists of directories, national brands, franchises and lead generators; " +
  "then any business with a Google Maps listing counts as a local business. Everything else is unclassified. " +
  "Click a type in the table to correct it.";

// The advertisers broken down by business type: total advertisers, then one
// row per type - its share of all appearances (ads, map pack, organic) as a
// soft purple bar and a %, and how many advertisers. No colour per type
// (Scott, 15 Oct 2026: replaces the coloured donut). Expanded, the same
// breakdown, centred and larger.
export default function CompetitionTypeCard({ result, expandButton, expanded }) {
  const types = result.businessTypes;

  return (
    <div className={`${OVERVIEW.card} flex-1 min-h-0 overflow-auto`}>
      <div className="flex items-center justify-between gap-2">
        <div className={OVERVIEW.panelTitleRow}>
          <h3 className={OVERVIEW.panelTitle}>Competition type</h3>
          <span className={OVERVIEW.panelNote}>share of all appearances</span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className={`${OVERVIEW.link} cursor-help`} title={HOW_WE_CLASSIFY}>How we classify</span>
          {expandButton}
        </div>
      </div>

      <div className={expanded ? "max-w-2xl mx-auto mt-8 text-base" : ""}>
        <div className={COMPETITION.total}>
          <span className={COMPETITION.totalValue}>{result.totals.advertisers}</span>
          <span className={COMPETITION.totalLabel}>advertiser{result.totals.advertisers === 1 ? "" : "s"}</span>
        </div>

        {types.length === 0 ? (
          <p className="mt-3 text-xs text-slate-400">{providerError(result) ? `${providerError(result).label}.` : "No advertisers seen."}</p>
        ) : (
          <table className={COMPETITION.table}>
            <thead>
              <tr>
                <th className={`${COMPETITION.head} text-left`} />
                <th className={COMPETITION.head} />
                <th className={`${COMPETITION.head} text-right pl-3`}>Share</th>
                <th className={`${COMPETITION.head} text-right pl-3`}>Advertisers</th>
              </tr>
            </thead>
            <tbody>
              {types.map(t => {
                const percent = Math.round(t.share * 100);
                return (
                  <tr key={t.type} title={`${BUSINESS_TYPE_LABELS[t.type]}: ${percent}% of appearances, ${t.advertisers} advertisers`}>
                    <td className={COMPETITION.label}>{BUSINESS_TYPE_LABELS[t.type]}</td>
                    <td className={COMPETITION.barCell}>
                      <div className={COMPETITION.barTrack}><div className={COMPETITION.barFill} style={{ width: `${percent}%` }} /></div>
                    </td>
                    <td className={COMPETITION.share}>{percent}%</td>
                    <td className={COMPETITION.count}>{t.advertisers}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
